// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__4ZTjK","label":"CategoryService_label__3d6HX","location":"CategoryService_location__2unWx"};